import styled from 'styled-components'
import check from '../../../assets/certificates/AddParameter/Modal/check.svg'
import cross from '../../../assets/certificates/AddParameter/Modal/switch-cross.svg'
import arrowDown from '../../../assets/certificates/AddParameter/Modal/arrow-down.svg'

export const Container = styled.div`
    position: absolute;
    background-color: #fff;
    border-radius: 1vw;
    z-index: 1;
    width: 54vw;

    .redBorder {
        border: #FF0000 1px solid;
    }

    .disabledButton {
        pointer-events: none;
        background-color: #C4C4C4;
    }
`

export const HeaderDiv = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 52vw;
    margin-top: 2.8vh;
    margin-left: 1.2vw;
    margin-right: 0.7vw;
`

export const HeaderText = styled.h2`
    font-family: 'Inter', sans-serif;
    font-size: 1.4vw;
    font-weight: 700;
    margin-top: 0;
    margin-bottom: 0;
`

export const CloseDiv = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 2vw;
    cursor: pointer;
    width: 2.5vw;
    height: 2.5vw;

    :hover{
        background-color: #F4F4F4;
    }
`

export const CloseImg = styled.img`
    width: 0.8vw;
`

export const InputsDiv = styled.div`
    display: flex;
    width: 52vw;
    margin-right: 1vw;
    justify-content: space-between;

    .onInputsDiv {
        margin-left: 0;
        margin-right: 1.6rem;
    }
`

export const InputDiv = styled.div`
    margin-left: 1.5vw;
    margin-top: 2.4vh;
    position: relative;

    .empty {
        border: 0;
    }
`

export const InputLabel = styled.label`
    display: block;
    font-family: 'Inter', sans-serif;
    font-weight: 700;
    font-size: 0.9vw;
`

export const Input = styled.input`
    width: 50.6vw;
    height: 5.3vh;
    background-color: #EBEBEB;
    border: 0;
    border-radius: 2vw;
    margin-top: 0.8vh;
    padding-left: 1vw;
    padding-right: 1vw;

    :focus {
        outline: 0;
    }
`

export const TabsDiv = styled.div`
    display: flex;
    overflow-x: auto;
    background-color: #fff;
    border: 0;
    margin-left: 1.5vw;
    white-space: nowrap;
`

export const TabDiv = styled.div`
    display: flex;
    max-height: 4vh;
    width: auto;
    align-items: center;
    border: solid #C4C4C4 1px;
    border-radius: 1vw;
    outline: none;
    margin-top: 1vh;
    background-color: #fff;
    margin-right: 0.7vw;
    padding-right: 0.5vw;
    user-select: none;
`

export const TabsDotsImg = styled.img`
    width: 0.5vw;
    margin-left: 0.6vw;
`

export const TabsText = styled.p`
    font-size: 0.9vw;
    font-family: 'Inter', sans-serif;
    margin-left: 0.6vw;
    cursor: text;
`

export const InputEdit = styled.input`
    margin-left: 0.6vw;
    border: none;
    padding: .5rem;
    outline: none;
    background-color: gray;
`

export const TabsCloseImg = styled.img`
    width: 0.8vw;
    margin-left: 0.5vw;
    cursor: pointer;
`

export const MediumInput = styled.input`
    width: 40vw;
    height: 5.3vh;
    background-color: #EBEBEB;
    border: 0;
    border-radius: 2vw;
    margin-top: 0.8vh;
    padding-left: 1vw;
    padding-right: 1vw;

    :focus {
        outline: 0;
    }
`

export const CustomInput = styled.input`
    position: relative;
    bottom: 1px;
    background-color: #ebebeb;
    color: #000;
    height: 5.3vh;
    width: 9vw;
    margin-top: 1vh;
    padding-left: 1vw;
    padding-right: 2.4vw;
    border-radius: 2vw;
    border: 1px solid #e1e1e1;
    -webkit-appearance: none;
    -moz-appearance: none;
    background-image: url(${arrowDown});
    background-repeat: no-repeat;
    background-position-x: 7vw;
    background-position-y: 1.6vh;
    background-size: 18px 15px;

    :focus{
        outline: 0;
    }
`

export const SwitchDiv = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 2.4vh;
    margin-left: 1.5vw;
`

export const SwitchLabel = styled.label`
    font-weight: 700;
    font-size: 0.9vw;
    font-family: 'Inter', sans-serif;
`

export const SwitchBox = styled.label`
    display: inline-block;
    position: relative;
    margin-top: 1vh;
    width: 60px;
    height: 34px;
`

export const SwitchInput = styled.input`
    opacity: 0;
    width: 0;
    height: 0;

    :checked + .slider {
        background-color: #2196F3;
        border: 0;
        padding: 2px;
    }

    :focus + .slider {
        box-shadow: 0 0 1px #2196F3;
    }

    :checked + .slider:before {
        background-image: url(${check});
        background-repeat: no-repeat;
        background-position: center;
        background-size: 15px 15px;
        background-color: #fff;
        -webkit-transform: translateX(24px);
        -ms-transform: translateX(24px);
        transform: translateX(24px);
    }
`

export const SwitchSlider = styled.span`
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    -webkit-transition: .4s;
    transition: .4s;
    border-radius: 34px;
    border: #696969 2px solid;

    :before {
        display: block;
        position: relative;
        content: "";
        height: 24px;
        width: 24px;
        left: 5.5px;
        top: 2.8px;
        background-color: #696969;
        border-radius: 50%;
        transition: all 0.4s;
        background-image: url(${cross});
        background-repeat: no-repeat;
        background-position: center;
        background-size: 11px 11px;
    }
`

export const WarningDiv = styled.div`
    position: absolute;
    display: flex;
    width: 40vw;
    justify-content: end;
    right: 1.9vw;
    bottom: 7vh;
`

export const WarningText = styled.p`
    font-family: 'Inter', sans-serif;
    font-size: 0.9vw;
    color: #FF0000;
`

export const ButtonsDiv = styled.div`
    display: flex;
    position: relative;
    align-items: center;
    margin-left: 31.7vw;
`

export const CancelButton = styled.button`
    width: 8vw;
    height: 5.8vh;
    background-color: #fff;
    color: #0090D3;
    font-family: 'Inter', sans-serif;
    font-size: 1vw;
    font-weight: 700;
    margin-top: 2.5vh;
    margin-bottom: 2.5vh;
    border: 1px #0090D3 solid;
    border-radius: 3vw;
    cursor: pointer;
`

export const SaveButtonDiv = styled.div`
    display: flex;
    align-items: center;
    width: 11.5vw;
    height: 5.8vh;
    background-color: #0090D3;
    color: #fff;
    margin-top: 2.5vh;
    margin-bottom: 2.5vh;
    margin-left: 1vw;
    border-radius: 3vw;
    cursor: pointer;
    // pointer-events: none;
`

export const SaveButtonImage = styled.img`
    margin-left: 1vw;   
    width: 0.9vw;
`

export const SaveButtonText = styled.p`
    font-family: 'Inter', sans-serif;
    font-size: 1vw;
    font-weight: 700;
    margin-left: 0.6vw;
`
